const ZERO_CENTS = '00'

/**
 * Splits a formatted price ("$3,299.00") into its symbol, dollars and cents.
 * Zero cents are dropped so the price renders as "$3,299", matching the pricing mocks.
 */
export const splitFormattedPrice = (formattedPrice: string) => {
  const [, symbol = '', dollars = '', cents = ''] =
    formattedPrice.match(/^(\D*)([\d,.\s]*?)(?:[.,](\d{1,2}))?$/) ?? []

  return {
    symbol,
    dollars,
    cents: cents === ZERO_CENTS ? '' : cents,
  }
}
